import './accordion.scss';

/**
 * Init the Accordion component to enable better accessibility features.
 */
export default function Accordion() {
    const $wrapper = document.querySelectorAll('.accordion');

    if ($wrapper.length) {
        $wrapper.forEach(($el: Element, index: number) => {
            const $checkboxes = $el.querySelectorAll('.accordion-trigger');
            const $accordions = $el.querySelectorAll('.accordion-item');
            const $focusableElements = $el.querySelectorAll('.accordion-panel a[href], .accordion-panel button, .accordion-panel input, .accordion-panel select, .accordion-panel [tabindex]:not([tabindex="-1"])');
            $el.setAttribute('id', `accordion-${index}`);
            const accordionId = $el.getAttribute('id');
            let counter = 0;

            function handleAccordionChange(clickedAccordion: HTMLInputElement) {
                if (clickedAccordion.checked) {
                    (clickedAccordion?.parentElement as HTMLDivElement).setAttribute('aria-expanded', 'true');
                    const $panel = (clickedAccordion?.parentElement as HTMLDivElement).querySelector('.accordion-panel') as HTMLDivElement;
                    $panel.setAttribute('aria-hidden', 'false');

                    if($focusableElements.length) {
                        $focusableElements.forEach($item => {
                            $item.setAttribute('tabindex', '0');
                        })
                    }

                    $checkboxes.forEach(($checkbox: any) => {
                        if ($checkbox !== clickedAccordion) {
                            $checkbox.checked = false;
                            ($checkbox?.parentElement as HTMLDivElement).setAttribute('aria-expanded', 'false');
                            const $panel = ($checkbox?.parentElement as HTMLDivElement).querySelector('.accordion-panel') as HTMLDivElement;
                            $panel.setAttribute('aria-hidden', 'true');
                        }
                    });
                } else {
                    (clickedAccordion?.parentElement as HTMLDivElement).setAttribute('aria-expanded', 'false');
                    const $panel = (clickedAccordion?.parentElement as HTMLDivElement).querySelector('.accordion-panel') as HTMLDivElement;
                    $panel.setAttribute('aria-hidden', 'true');

                    if($focusableElements.length) {
                        $focusableElements.forEach(($item: Element) => {
                            $item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }

            function init() {
                $checkboxes.forEach(($checkbox: any) => {
                    $checkbox.addEventListener('change', () => {
                        handleAccordionChange($checkbox);
                    });
                });

                if($focusableElements.length) {
                    $focusableElements.forEach(($item: Element) => {
                        $item.setAttribute('tabindex', '-1');
                    })
                }

                $accordions.forEach(($accordion: Element) => {
                    const $label = $accordion.querySelector('label') as HTMLElement;
                    const $input = $accordion.querySelector('input') as HTMLInputElement;

                    const uniqueId = `accordion-${counter++}-${accordionId}`;
                    $label.setAttribute('for', uniqueId);
                    $input.setAttribute('id', uniqueId);

                    $label.addEventListener('keypress', (e: KeyboardEvent) => {
                        if (e.key === 'Enter') {
                            $input.click();
                        }
                    });
                });
            }

            init();
        });
    }
}
